<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-extra-amenities"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant().code+'/concierge'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-7">
                        <div class="">
                          <transition name="fade">
                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1" v-if="scrollPosition >40">{{$t('hotel.menu.extra-amenities')}}</p>
                          </transition>
                        </div>
                      </div>
                      <div class="col-4 text-right">
                        <div class="mt-1">
                          <transition name="fade">
                            <div class="bg-light w-30px rounded-100 d-inline-block" @click="toSearch()" v-if="scrollPosition>100">
                              <img src="../../../../assets/img/hotel/search.png" width="15" class="search-in-nav">
                            </div>
                          </transition>
                          <!-- <img src="../../../../assets/img/hotel/avatar-img.jpg" width="30" height="30" class="ml-2 rounded-100 object-fit d-inline-block"> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-50px"></div>
    <div v-if="category.is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="category.error != ''" :message="category.error" />
      <template v-else>
        <div class="container px-4 pb-1">
          <p class="mb-0 body-1-1 text-26">{{$t('hotel.menu.extra-amenities')}}</p>
          <div class="mb-2 mt-1">
            <input type="text" :placeholder="$t('hotel.concierge.search.extra-amenities')" ref="search" class="w-100 border-none body-2-1 ls-0-1 bg-light search-custom rounded-6" v-model="search" />
          </div>
        </div>
        <div class="container px-4 pt-2 sticky bg-white" :class="{'box-shadow-nav':scrollPosition >100}" style="top: 52px;z-index: 1038">
          <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0" @click="xScroll('left', 'room')">
            <img src="../../../../assets/img/icon/orange-arrow-left.png" width="18" class="next-button position-relative" style="left: 0;z-index: 9">
          </div>
          <div class="div-wrapper mx-auto d-inline-block m-width-100 position-relative left-0-d pb-1" id="room" style="width: 97%;">
            <div class="text-center" style="width: max-content">
              <div class="text-center d-inline-block cursor-pointer" v-for="(data, index) in category.list" @click="changeCategory(data)">
                <p class="body-2 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer text-12 bg-light-page mr-2 rounded-3" :class="{'font-bold delay bg-orange text-white border-orange':category.selected.id == data.id}">{{data.name}}</p>
              </div>
            </div>
          </div>
          <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 0;" @click="xScroll('right', 'room')">
            <img src="../../../../assets/img/icon/orange-arrow-right.png" width="18" class="next-button position-relative" style="right: 11px;z-index: 9">
          </div>
        </div>
      </template>
    </template>


    <div class="container px-4">
      <div v-if="product.is_load" class="w-100 py-4 text-center">
        <loader v-if="!category.is_load" />
      </div>
      <template v-else>
        <ErrorMessage v-if="product.error != ''" :message="product.error" />
        <template v-else>
          <p v-if="product.list.length == 0" class="mt-4 mb-0 body-2-2 font-semibold text-center">{{$t('warning-message.search-not-found.extra-amenities')}}</p>
          <template v-else>
            <template v-for="product_category in product.list">
              <p class="mt-4 mb-3 body-2-2 text-20 font-bold">{{product_category.name}}</p>
              <div class="mb-3">
                <template v-for="product_data in product_category.product">
                  <menuNoImage @detail="changeProductSelected" :data="product_data" />
                </template>
              </div>
              <div class="w-100" v-if="category.selected.id == 'all' && product_category.total_product > 2">
                <p class="d-table px-2 py-1 mb-0 body-3-3 font-semibold text-orange ml-auto border-orange rounded-4 cursor-pointer" @click="changeCategory({id:product_category.id,name:product_category.name})">Load more</p>
              </div>
            </template>
          </template>
        </template>
      </template>
    </div>
    <!-- <div class="container px-4 pt-3 text-center" v-if="filter_search == ''">
      <img src="../../../../assets/img/icon/404.png" width="150" class="text-center">
      <p class="mb-0 mt-3 body-2-2 text-16 font-bold">"{{search_model}}"</p>
      <p class="mb-0 body-2-2 font-semibold">Search was not found, please search for a different search</p>
    </div> -->
    <div class="height-40px"></div>
    <!-- Pop Up Cart -->
    <transition name="fade">
      <template v-if="Object.keys(product.selected).length > 0">
        <menuVariantDetail @done="changeProductSelected" :data="product.selected" />
      </template>
    </transition>
    <cartPopup item_title="Item" cart_link="/concierge/extra-amenities/cart"></cartPopup>
    <bottom-navbar></bottom-navbar>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {get} from '@/services/index.js';
  import Flickity from 'vue-flickity';
  import menuNoImage from '@/components/hotel/concierge/general/menuNoImage'
  import menuVariantDetail from '@/components/hotel/concierge/general/menuVariantDetail'
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import cartPopup from '@/components/hotel/concierge/general/cartPopup'

  export default{
    components: {
      Flickity,
      BottomNavbar,
      menuNoImage,
      menuVariantDetail,
      cartPopup
    },
    metaInfo(){
      return {
        title: 'Extra Amenities',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        scrollPosition: null,
        is_popup: '',
        is_cart: false,
        counter: 0,
        deincrement: '',
        is_category: 1,
        search_model: '',


        // fix
        category:{
          list: [],
          selected: {
            id: 'all',
            name: this.$t('hotel.concierge.all-category')
          },
          is_load: true,
          error: ''
        },
        product: {
          list: [],
          is_load: true,
          error: '',
          selected: {}
        },
        search: ''
      }
    },
    methods: {
      ...mapGetters(['getMerchant','getMetaTitleTemplate']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
        console.log(content.scrollLeft)
      },
      toSearch(){
        this.$refs['search'].focus()
        document.getElementById('hotel-extra-amenities').scrollIntoView({
          behavior: 'smooth'
        });
      },
      toMenu(data, type){
        if (type == 'close') {
          this.is_popup = false
        }else{
          this.is_popup = type
          this.detail_menu = data
        }
      },
      toCart(data){
        this.is_cart = true
        this.deincrement = data
        this.is_popup = 'close'
        
      },
      changeCategory(data){
        this.category.selected = data
        this.loadAllProduct()
      },
      changeProductSelected(data_detail=false){
        this.product.selected = data_detail == false ? {} : data_detail
      },
      loadProductCategory(){
        this.category = {
          is_load: true,
          error: '',
          list : [],
          selected: {
            id: 'all',
            name: this.$t('hotel.concierge.all-category')
          }
        }
        get("CONCIERGE", "extra-amenities/category-option",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.category.list.push({
              id: 'all',
              name: this.$t('hotel.concierge.all-category')
            })
            for(let cat of res.data){
              this.category.list.push(cat)
            }
            this.category.selected = this.category.list[0]
          }else{
            this.category.error = res.message
          }
          this.category.is_load = false
        })
      },
      loadAllProduct(){
        this.product = {
          list: [],
          is_load: true,
          error: '',
          selected: {}
        }
        get("CONCIERGE", "extra-amenities/product",{
          merchant_id: this.getMerchant().id,
          category_id: this.category.selected.id == 'all' ? '' : this.category.selected.id,
          keyword: this.search
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.product.list = res.data
          }else{
            this.product.error = res.message
          }
          this.product.is_load = false
        })
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-extra-amenities').scrollIntoView({
        behavior: 'smooth'
      });
    },
    computed: {
      filter_search(){
        return this.product.filter((item)=>{
          return item.name.toString().toLowerCase().match(this.search_model.toLowerCase())
        })
      }
    },
    watch:{
      search(){
        this.loadAllProduct()
      }
    }
  }
</script>
<style scoped>
.search-custom {
  background-image: url('../../../../assets/img/hotel/search.png');
  height: 44px;
  background-color: #f4f4f4b8  !important;
  background-position: 16px 14px;
  background-size: 15px 15px;
  -o-object-fit: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 5px 30px 7px 44px;
}

.left-0-d{
  left: 0!important
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/extraamenities/ExtraAmenities.vue